export const UNAUTHORIZED = 401
export const NOT_FOUND = 404
